import { render, staticRenderFns } from "./SellProduct.vue?vue&type=template&id=bba79bb8&scoped=true"
import script from "./SellProduct.vue?vue&type=script&lang=js"
export * from "./SellProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba79bb8",
  null
  
)

export default component.exports